import React from 'react';
import { useSelector } from 'react-redux';
import { Point } from '@printu/geom';
import { getElementFrame } from 'app/utils/DOM';
import { call, noop } from 'app/utils/function';
const getElement = (ref) => {
    const { current } = ref;
    if (!current) {
        return null;
    }
    if (current instanceof HTMLElement) {
        return current;
    }
    return current.UNSAFE_getDOMNode();
};
export const useMouseDrag = (ref, handlers, options) => {
    const opts = React.useMemo(() => (Object.assign({ workspace: 'canvas' }, options)), [options]);
    const down = React.useRef(null);
    const viewport = useSelector((state) => state.viewport);
    const { onDragStart, onDrag, onDragEnd } = handlers;
    React.useEffect(() => {
        const el = getElement(ref);
        if (!el) {
            return noop;
        }
        const getEventPoint = (evt) => {
            const frame = getElementFrame(el);
            const elPoint = new Point(evt.clientX - frame.x, evt.clientY - frame.y);
            return elPoint;
        };
        const $onMouseDown = (evt) => {
            if (!down.current) {
                const point = getEventPoint(evt);
                down.current = point;
                call(onDragStart, point, evt);
            }
        };
        const $onMouseMove = (evt) => {
            if (down.current) {
                const point = getEventPoint(evt);
                call(onDrag, point, down.current, evt);
                evt.stopImmediatePropagation();
            }
        };
        const $onMouseUp = (evt) => {
            if (down.current) {
                if (evt instanceof MouseEvent) {
                    const point = getEventPoint(evt);
                    call(onDragEnd, point, down.current, evt);
                }
                down.current = null;
            }
        };
        const eventHandlers = {
            mousemove: $onMouseMove,
            dragover: $onMouseMove,
            mousedown: $onMouseDown,
            mouseup: $onMouseUp,
            contextmenu: $onMouseUp,
            visibilitychange: $onMouseUp,
        };
        Object.keys(eventHandlers).forEach(eventType => el.addEventListener(eventType, eventHandlers[eventType]));
        return () => {
            Object.keys(eventHandlers).forEach(eventType => el.removeEventListener(eventType, eventHandlers[eventType]));
        };
    }, [ref, opts, viewport, onDragStart, onDrag, onDragEnd]);
    return [];
};
